/** Roles that should behave the same as Mid Office Role across the app. */
export const MID_OFFICE_ROLE_ABBREVIATIONS: Record<string, string> = {
  "Mid Office Role": "MO",
  "Claim Processing Executive": "CPE",
  "Claim Processing Doctor": "CPD",
  "Claim Processing Manager": "CPM",
  "Manager Revenue Assurance": "MRA",
  "Executive Revenue Assurance": "ERA",
  "Accounts Receivable Executive": "ARE",
  "Accounts Receivable Manager": "ARM",
  "Quality Check Executive": "QCE",
  "Quality Check Manager": "QCM",
};

export const MID_OFFICE_EQUIVALENT_ROLES = Object.keys(
  MID_OFFICE_ROLE_ABBREVIATIONS,
) as Array<keyof typeof MID_OFFICE_ROLE_ABBREVIATIONS>;

const MID_OFFICE_ROLE_SET = new Set<string>(MID_OFFICE_EQUIVALENT_ROLES);

const MID_OFFICE_ABBREVIATION_SET = new Set<string>(
  Object.values(MID_OFFICE_ROLE_ABBREVIATIONS),
);

export const isMidOfficeRole = (role?: string | null): boolean =>
  !!role &&
  (MID_OFFICE_ROLE_SET.has(role) || MID_OFFICE_ABBREVIATION_SET.has(role));

/** Abbreviation map for Mid Office and equivalent roles (full name and abbreviation keys). */
export const midOfficeRoleAbbreviations: Record<string, string> = {
  ...MID_OFFICE_ROLE_ABBREVIATIONS,
  ...Object.fromEntries(
    Object.values(MID_OFFICE_ROLE_ABBREVIATIONS).map((abbr) => [abbr, abbr]),
  ),
};

export const getMidOfficeDepartmentLabel = (
  role?: string | null,
): string | null => (isMidOfficeRole(role) ? `GSEVENPRO ${role}` : null);

export const getRoleAbbreviation = (role?: string | null): string => {
  if (!role) return "";
  if (MID_OFFICE_ROLE_ABBREVIATIONS[role]) return MID_OFFICE_ROLE_ABBREVIATIONS[role];
  if (MID_OFFICE_ABBREVIATION_SET.has(role)) return role;
  return "";
};
